/* DEV-289 (2026-09-26): product card behaviour for the approved design.
   - photo swipe: photos 2-3 load on the first touch, hover or focus of the card; the dots follow the scroll position; on a mouse, hovering shows the second photo (as the old hover image did);
   - after a colour swatch click (assets/lm-plp-card.js swaps the 1st and 2nd photo) photos of the old colour are removed;
   - heart: saved list in this browser (localStorage "lm-atranka", product handles, newest first); DEV-292 builds the list page;
   - "+": size sheet for the card's colour; a size tap adds it to the cart with the theme's own flow
     (cart/add.js with bundled sections, then "variant:add" and "cart:change"), so the cart drawer opens as usual. */
const lmCard = window.__lmCard || (window.__lmCard = {});

if (!lmCard.ready) {
  lmCard.ready = true;

  const TEXT = {
    en: { choose: 'Choose your size', details: 'Full product details', close: 'Close', save: 'Save to wishlist', out: 'sold out', error: 'Could not add. Please try again.', added: 'Item added. The cart could not refresh. Open your cart.' },
    lt: { choose: 'Pasirink dydį', details: 'Visa informacija apie prekę', close: 'Uždaryti', save: 'Į atranką', out: 'išparduota', error: 'Nepavyko įdėti. Bandyk dar kartą.', added: 'Prekė pridėta, bet krepšelio nepavyko atnaujinti. Atverk krepšelį.' },
    de: { choose: 'Größe wählen', details: 'Alle Produktdetails', close: 'Schließen', save: 'Auf die Merkliste', out: 'ausverkauft', error: 'Konnte nicht hinzugefügt werden. Bitte versuchen Sie es erneut.', added: 'Artikel hinzugefügt. Der Warenkorb konnte nicht aktualisiert werden. Bitte öffnen Sie den Warenkorb.' },
    da: { choose: 'Vælg størrelse', details: 'Alle produktdetaljer', close: 'Luk', save: 'Gem på ønskelisten', out: 'udsolgt', error: 'Kunne ikke tilføjes. Prøv igen.', added: 'Varen er tilføjet. Kurven kunne ikke opdateres. Åbn kurven.' },
    fi: { choose: 'Valitse koko', details: 'Kaikki tuotetiedot', close: 'Sulje', save: 'Tallenna toivelistalle', out: 'loppuunmyyty', error: 'Lisääminen epäonnistui. Yritä uudelleen.', added: 'Tuote lisätty. Ostoskoria ei voitu päivittää. Avaa ostoskori.' },
    fr: { choose: 'Choisissez votre taille', details: 'Tous les détails du produit', close: 'Fermer', save: 'Ajouter à ma sélection', out: 'épuisé', error: "Ajout impossible. Veuillez réessayer.", added: "Article ajouté. Le panier n'a pas pu être actualisé. Ouvrez votre panier." },
    nl: { choose: 'Kies je maat', details: 'Alle productdetails', close: 'Sluiten', save: 'Bewaar in je verlanglijst', out: 'uitverkocht', error: 'Toevoegen mislukt. Probeer het opnieuw.', added: 'Artikel toegevoegd. De winkelwagen kon niet worden vernieuwd. Open je winkelwagen.' },
    no: { choose: 'Velg størrelse', details: 'Alle produktdetaljer', close: 'Lukk', save: 'Lagre i ønskelisten', out: 'utsolgt', error: 'Kunne ikke legges til. Prøv igjen.', added: 'Varen er lagt til. Handlekurven kunne ikke oppdateres. Åpne handlekurven.' },
    sv: { choose: 'Välj storlek', details: 'Alla produktdetaljer', close: 'Stäng', save: 'Spara i önskelistan', out: 'slutsåld', error: 'Kunde inte läggas till. Försök igen.', added: 'Varan har lagts till. Varukorgen kunde inte uppdateras. Öppna varukorgen.' }
  };
  const lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  const t = TEXT[lang === 'nb' ? 'no' : lang] || TEXT.en;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const KEY = 'lm-atranka';
  const esc = (value) => String(value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  /* ---------- saved list (heart) ---------- */
  const readSaved = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  };

  const writeSaved = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (error) {}
    document.dispatchEvent(new CustomEvent('lm:atranka', { detail: { items: list } }));
  };

  const syncHearts = (scope) => {
    const saved = new Set(readSaved());
    scope.querySelectorAll('[data-lm-heart]').forEach((button) => {
      button.setAttribute('aria-pressed', saved.has(button.dataset.lmHeart) ? 'true' : 'false');
      button.setAttribute('aria-label', t.save);
    });
  };

  /* DEV-370: every ♡ that saves a product is sent to Klaviyo as "LM Heart" (public key only) for the sales pulse page.
     No name or e-mail: the profile is a random id kept in this browser; one event per person, product and day (unique_id).
     DEV-451 (2026-09-28, Audrius: "Taip, anonimiškai"): when analytics consent is refused the heart is still counted, but
     anonymously: no lm_anon id is read or stored, every such event goes to one shared profile "lm-heart-noconsent" with
     AnonId "" and Consent "no", and each tap has its own unique_id (no per-day dedupe). With consent: as before + Consent
     "yes". Errors are ignored. */
  const KLAVIYO_KEY = 'XHparJ';
  const ANON_KEY = 'lm_anon';
  const heartSurface = (button) => {
    if (button.closest('product-recommendations, [data-lm-similar]')) return 'similar';
    const path = location.pathname.replace(/\/+$/, '');
    if (/\/products\//.test(path)) return 'pdp';
    if (/\/collections\//.test(path)) return 'collection';
    if (path === '' || path === root.replace(/\/+$/, '')) return 'home';
    return 'collection';
  };
  const sendHeart = (button, handle) => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      const consent = !(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === false);
      const randomId = () => (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2));
      let anon = '';
      if (consent) {
        anon = localStorage.getItem(ANON_KEY);
        if (!anon) {
          anon = 'lm-' + randomId();
          localStorage.setItem(ANON_KEY, anon);
        }
      }
      const surface = heartSurface(button);
      const day = new Date().toISOString().slice(0, 10);
      const send = (product) => {
        const properties = {
          ProductHandle: handle,
          ProductID: product && product.id ? String(product.id) : '',
          ProductName: product && product.title ? product.title : handle,
          AnonId: anon,
          Consent: consent ? 'yes' : 'no',
          Surface: surface,
          Country: (window.Shopify && window.Shopify.country) || '',
          URL: location.origin + root + 'products/' + handle
        };
        fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_KEY, {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2025-07-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties,
            unique_id: consent ? anon + '-' + handle + '-' + day : randomId(),
            metric: { data: { type: 'metric', attributes: { name: 'LM Heart' } } },
            profile: { data: { type: 'profile', attributes: { anonymous_id: consent ? anon : 'lm-heart-noconsent' } } }
          } } })
        }).catch(() => {});
      };
      fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .catch(() => null)
        .then(send);
    } catch (error) {}
  };

  const toggleSaved = (button) => {
    const handle = button.dataset.lmHeart;
    let list = readSaved();
    const adding = !list.includes(handle);
    list = adding ? [handle].concat(list) : list.filter((item) => item !== handle);
    writeSaved(list);
    syncHearts(document);
    if (adding) sendHeart(button, handle);
  };

  window.addEventListener('storage', (event) => {
    if (event.key === KEY) syncHearts(document);
  });

  /* ---------- photo swipe ---------- */
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  /* DEV-503 (2026-09-29): the photo link (.lm-gal) is the element that scrolls, so the swipe row is reachable by keyboard
     (axe scrollable-region-focusable); .lm-track only lays the photos out */
  const scroller = (track) => track.closest('.lm-gal') || track;

  const trackIndex = (track) => Math.round(Math.abs(scroller(track).scrollLeft) / Math.max(1, scroller(track).clientWidth));

  /* CRO-64 (2026-10-16): the dots are one <i> (assets/lm-card.css draws 2-3 from it); data-i marks the photo shown */
  const syncDots = (track) => {
    const box = track.closest('.product-card__figure')?.querySelector('.lm-dots');
    if (box) box.dataset.i = String(trackIndex(track));
  };

  /* CRO-64: photos 2-3 come as data-lm-more ([url, width, height, alt] each, snippets/product-card.liquid) and get their
     <img> here, with the srcset the card used to print (widths 240-960 up to the photo's own width) */
  const moreWidths = [240, 480, 600, 720, 960];
  const sizedUrl = (url, width) => url.replace(/([?&])width=\d+/, '$1width=' + width);
  const makeImage = (url, width, height, alt, secondary, sizes) => {
    const image = document.createElement('img');
    const widths = moreWidths.filter((value) => value <= width);
    image.alt = alt || '';
    if (width) image.width = width;
    if (height) image.height = height;
    image.loading = 'lazy';
    image.setAttribute('fetchpriority', 'low');
    if (sizes) image.sizes = sizes;
    image.className = 'product-card__image' + (secondary ? ' product-card__image--secondary' : '');
    image.srcset = (widths.length ? widths : [width]).map((value) => sizedUrl(url, value) + ' ' + value + 'w').join(', ');
    image.src = url;
    return image;
  };
  const buildMore = (card) => {
    const track = card.querySelector('.lm-track[data-lm-more]');
    if (!track) return;
    /* a card copied without its dots (the shelf at the end of a collection, assets/lm-collection.js) keeps one photo */
    if (!card.querySelector('.lm-dots')) {
      track.removeAttribute('data-lm-more');
      return;
    }
    let list = [];
    try {
      list = JSON.parse(track.dataset.lmMore) || [];
    } catch (error) {}
    track.removeAttribute('data-lm-more');
    const first = track.querySelector('img');
    list.forEach((item, position) => track.append(makeImage(item[0], item[1], item[2], item[3], position === 0, first && first.sizes)));
  };

  /* photos 2-3 are printed without src (data-lm-src / data-lm-srcset) and load when the shopper reaches for the card */
  const hydrate = (card) => {
    buildMore(card);
    card.querySelectorAll('img[data-lm-srcset]').forEach((image) => {
      /* a colour swatch may already have set this photo (lm-plp-card.js); keep that one */
      if (!image.getAttribute('srcset')) {
        image.srcset = image.dataset.lmSrcset;
        image.src = image.dataset.lmSrc || '';
      }
      image.removeAttribute('data-lm-srcset');
      image.removeAttribute('data-lm-src');
    });
  };

  /* a card inside a sideways row (home shelves, "Similar styles", "Pair it with", the saved row in the cart) */
  const inRow = (card) => {
    for (let node = card.parentElement; node && node !== document.body; node = node.parentElement) {
      const overflow = getComputedStyle(node).overflowX;
      /* only a row that really scrolls sideways; a carousel wrapper holding a 2-column grid is not a row */
      if ((overflow === 'auto' || overflow === 'scroll') && node.scrollWidth > node.clientWidth + 1) return true;
    }
    return false;
  };

  const bindCard = (card) => {
    if (!card || card.__lmCardBound) return;
    card.__lmCardBound = true;
    syncHearts(card);

    const track = card.querySelector('.lm-track');
    if (track && track.dataset.lmMore && !card.querySelector('.lm-dots')) track.removeAttribute('data-lm-more');
    if (!track || (track.children.length < 2 && !track.dataset.lmMore)) return;

    ['touchstart', 'pointerenter', 'focusin'].forEach((type) => card.addEventListener(type, () => hydrate(card), { once: true, passive: true }));

    /* 2026-09-26 (Audrius: swiping the photos in a row stopped the row itself): inside a sideways row the photo track
       does not scroll by touch, so a sideways swipe moves the whole row; the photos change by the dots there.
       Cards in a grid keep the photo swipe. */
    const markRow = () => card.classList.toggle('lm-in-row', inRow(card));
    markRow();
    card.addEventListener('touchstart', markRow, { passive: true, capture: true });
    const dotsBox = card.querySelector('.lm-dots');
    if (dotsBox) {
      dotsBox.addEventListener('click', (event) => {
        if (!card.classList.contains('lm-in-row')) return;
        event.preventDefault();
        event.stopPropagation();
        /* a tap on a dot opens that photo, elsewhere on the dots the next or previous one (CRO-64: dot centres are
           worked out from the one <i>, one dot plus --lm-dot-gap apart) */
        const count = Number(dotsBox.dataset.n) || 1;
        const dot = dotsBox.firstElementChild;
        let index = -1;
        if (dot) {
          const rect = dot.getBoundingClientRect();
          const step = rect.width + (parseFloat(getComputedStyle(dotsBox).getPropertyValue('--lm-dot-gap')) || 0);
          const centre = rect.left + rect.width / 2;
          for (let position = 0; position < count; position += 1) {
            const x = centre + (position - (count - 1) / 2) * step;
            if (Math.abs(event.clientX - x) <= rect.height / 2 && Math.abs(event.clientY - (rect.top + rect.height / 2)) <= rect.height / 2) index = position;
          }
        }
        if (index < 0) {
          const box = dotsBox.getBoundingClientRect();
          index = event.clientX > box.left + box.width / 2 ? Math.min(trackIndex(track) + 1, count - 1) : Math.max(trackIndex(track) - 1, 0);
        }
        hydrate(card);
        scroller(track).scrollTo({ left: index * scroller(track).clientWidth * (getComputedStyle(track).direction === 'rtl' ? -1 : 1), behavior: 'smooth' });
      });
    }

    let frame = 0;
    scroller(track).addEventListener('scroll', () => {
      hydrate(card);
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => syncDots(track));
    }, { passive: true });

    /* 2026-09-26 (Audrius: hover got in the way of browsing): on a mouse the second photo fades in over the first once it has
       loaded; the gallery no longer jumps to photo 2 and never shows an empty grey frame while that photo loads */
    const figure = card.querySelector('.product-card__figure');
    const gal = card.querySelector('.lm-gal') || track.parentElement;
    let over = false;
    const layer = () => {
      const second = track.children[1];
      if (!second || !second.getAttribute('src')) return null;
      let img = gal.querySelector(':scope > .lm-hover-img');
      if (!img) {
        img = document.createElement('img');
        img.className = 'lm-hover-img';
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.decoding = 'async';
        gal.append(img);
      }
      if (img.dataset.for !== second.currentSrc + '|' + second.getAttribute('src')) {
        img.sizes = second.sizes;
        img.srcset = second.getAttribute('srcset') || '';
        img.src = second.getAttribute('src');
        img.dataset.for = second.currentSrc + '|' + second.getAttribute('src');
      }
      return img;
    };
    figure.addEventListener('mouseenter', () => {
      if (!fine.matches || trackIndex(track) !== 0) return;
      hydrate(card);
      if (track.children.length < 2) return;
      over = true;
      const img = layer();
      if (!img) return;
      const show = () => { if (over && trackIndex(track) === 0) img.classList.add('on'); };
      if (img.complete && img.naturalWidth) show();
      else img.addEventListener('load', show, { once: true });
    });
    figure.addEventListener('mouseleave', () => {
      over = false;
      gal.querySelector(':scope > .lm-hover-img')?.classList.remove('on');
    });
    scroller(track).addEventListener('scroll', () => {
      if (trackIndex(track) !== 0) gal.querySelector(':scope > .lm-hover-img')?.classList.remove('on');
    }, { passive: true });
  };

  /* colour swatch: lm-plp-card.js swaps the 1st and 2nd photo, so drop photos of the old colour */
  const onColour = (event) => {
    const input = event.target.closest && event.target.closest('input[data-variant-media]');
    const card = input && input.closest('product-card');
    const track = card && card.querySelector('.lm-track');
    if (!track) return;

    setTimeout(() => {
      /* keep the 2nd photo only when the new colour has its own second photo (not a repeat of the first) */
      let keep = 1;
      let second = null;
      try {
        const first = JSON.parse(input.dataset.variantMedia || 'null');
        second = JSON.parse(input.dataset.variantSecondaryMedia || 'null');
        if (second && second.preview_image && (!first || !first.preview_image || second.preview_image.src !== first.preview_image.src)) keep = 2;
      } catch (error) {}
      /* CRO-64: a colour picked before photos 2-3 were built (no touch, hover or focus on the card first): skip the
         old colour's photos and add the new colour's second photo, as the swatch scripts would have */
      if (track.dataset.lmMore) {
        track.removeAttribute('data-lm-more');
        if (keep === 2 && track.children.length < 2) {
          const first = track.querySelector('img');
          const preview = second.preview_image;
          track.append(makeImage(preview.src + (preview.src.includes('?') ? '&' : '?') + 'width=' + preview.width, preview.width, preview.height, second.alt, true, first && first.sizes));
        }
      }
      Array.from(track.children).slice(keep).forEach((image) => image.remove());
      const dots = card.querySelector('.lm-dots');
      if (dots) {
        if (keep < 2) {
          dots.remove();
        } else {
          dots.dataset.n = String(Math.min(keep, Number(dots.dataset.n) || keep));
        }
      }
      scroller(track).scrollTo({ left: 0, behavior: 'instant' });
      syncDots(track);
    }, 0);
  };

  document.addEventListener('change', onColour);

  /* ---------- DEV-525: size buttons on the card ---------- */
  const productCache = {};
  const loadProduct = (card) => {
    const handle = card.getAttribute('handle');
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js').then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      });
      productCache[handle].catch(() => delete productCache[handle]);
    }
    return productCache[handle];
  };

  /* after a colour change the buttons follow the new colour's variants */
  const refreshSizes = async (card) => {
    const box = card.querySelector('[data-lm-qs]');
    if (!box) return;
    let product;
    try { product = await loadProduct(card); } catch (error) { return; }
    const sizeIndex = Number(box.dataset.lmQs);
    const current = (product.variants || []).find((variant) => variant.id === cardVariantId(card));
    const swatchList = card.querySelector('[data-option-position]');
    const colourIndex = swatchList ? Number(swatchList.dataset.optionPosition) - 1 : -1;
    box.querySelectorAll('[data-lm-qs-size]').forEach((button) => {
      const variant = (product.variants || []).find((item) => String(item.options[sizeIndex]) === button.dataset.lmQsSize
        && (colourIndex < 0 || !current || item.options[colourIndex] === current.options[colourIndex]));
      button.hidden = !variant;
      if (!variant) return;
      button.dataset.variantId = variant.id;
      button.disabled = !variant.available;
      button.setAttribute('aria-label', variant.available ? button.dataset.add + ': ' + (product.title || '').split(/\s[–—-]\s/)[0] + ', ' + button.dataset.lmQsSize : button.dataset.lmQsSize + ', ' + button.dataset.out);
    });
  };
  document.addEventListener('change', (event) => {
    const input = event.target.closest && event.target.closest('input[data-variant-media]');
    const card = input && input.closest('product-card');
    if (card) setTimeout(() => refreshSizes(card), 0);
  });

  const quickSize = async (card, button) => {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const variantId = Number(button.dataset.variantId);
    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    const body = new FormData();
    body.set('id', variantId);
    body.set('quantity', '1');
    body.set('sections', sections.join(','));
    body.set('sections_url', root + 'variants/' + variantId);
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || json.message || t.error);
      const cart = await (await fetch(root + 'cart.js')).json();
      cart.sections = json.sections;
      button.removeAttribute('aria-busy');
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1600);
      if (window.clarity) window.clarity('event', 'lm_card_size_add');
      card.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.hasOwnProperty('items') ? json.items : [json], cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
    } catch (failure) {
      /* the size sheet shows the reason and lets the shopper pick again */
      button.removeAttribute('aria-busy');
      openSheet(card, button);
    }
  };

  /* UI13: explicit size selection using the existing bundled cart flow. */
  let sheet, scrim, opener, openerSection, openerHandle, previousOverflow;
  let requestSequence = 0;
  let cartPending = false;
  let inertState = [];
  let selectedVariant = null;
  const ensureChoiceStyle = (source) => {
    if (!source || document.querySelector('link[data-lm-choice-style]')) return;
    const style = document.createElement('link'); style.rel = 'stylesheet'; style.href = source;
    style.dataset.lmChoiceStyle = ''; document.head.append(style);
  };
  /* The deferred card script runs after card markup; load shared choice CSS once up front. */
  ensureChoiceStyle(document.querySelector('[data-lm-choice-css]')?.dataset.lmChoiceCss);

  const visibleFocusable = (element) => element && !element.disabled && !element.hidden && !element.closest('[inert]') && element.getClientRects().length;
  const sheetFocusables = (target) => Array.from(target.querySelectorAll('button,a[href],input,[tabindex="0"]')).filter(visibleFocusable);
  const restoreOpener = () => {
    let target = opener;
    if (!visibleFocusable(target) || !target.isConnected) {
      const scope = openerSection && document.getElementById(openerSection) || document;
      target = Array.from(scope.querySelectorAll('product-card')).find((card) => card.getAttribute('handle') === openerHandle)?.querySelector('[data-lm-qadd]');
    }
    if (visibleFocusable(target)) target.focus({preventScroll:true});
  };
  const closeSheet = (returnFocus = true) => {
    requestSequence++;
    if (!sheet) return;
    const oldSheet = sheet, oldScrim = scrim;
    sheet = scrim = null;
    selectedVariant = null;
    oldSheet.remove(); oldScrim.remove();
    inertState.forEach(([element, value]) => { if (element.isConnected) element.inert = value; });
    inertState = [];
    document.documentElement.style.overflow = previousOverflow;
    if (returnFocus) restoreOpener();
  };
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && sheet) { event.preventDefault(); closeSheet(); }
  });
  const cardVariantId = (card) => {
    const checked = card.querySelector('input[data-variant-media]:checked');
    if (checked && checked.dataset.variantId) return Number(checked.dataset.variantId);
    if (card.dataset.plpSelectedVariant) return Number(card.dataset.plpSelectedVariant);
    const link = card.querySelector('.product-card__figure > a');
    const variant = link && new URL(link.href, location.href).searchParams.get('variant');
    return variant ? Number(variant) : 0;
  };
  const addToCart = async (card, button, variantId) => {
    const targetSheet = sheet;
    if (!targetSheet || cartPending || targetSheet.dataset.cartAdded === 'true') return;
    const error = targetSheet.querySelector('.lm-sheet-err');
    if (!variantId) {
      error.textContent = t.choose; error.hidden = false;
      targetSheet.querySelector('.lm-sizes').focus();
      return;
    }
    error.hidden = true;
    cartPending = true;
    button.setAttribute('aria-busy','true');
    targetSheet.querySelectorAll('[data-lm-size]').forEach((item) => {item.disabled = true;});
    const sections = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true, detail:{sections}}));
    const body = new FormData();
    body.set('id',variantId); body.set('quantity','1'); body.set('sections',sections.join(','));
    body.set('sections_url',root + 'variants/' + variantId);
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', body, headers:{'X-Requested-With':'XMLHttpRequest'}});
      /* A successful HTTP add is accepted even if its body cannot be decoded. */
      if (response.ok) targetSheet.dataset.cartAdded = 'true';
      const json = await response.json();
      /* the shop's own message (e.g. sold out) is shown as is; browser and parsing errors get the local text */
      if (!response.ok) throw Object.assign(new Error(json.description || json.message || t.error), {lmShop: true});
      const cartResponse = await fetch(root + 'cart.js');
      if (!cartResponse.ok) throw new Error(t.error);
      const cart = await cartResponse.json();
      cart.sections = json.sections;
      if (sheet === targetSheet) closeSheet();
      card.dispatchEvent(new CustomEvent('variant:add', {bubbles:true, detail:{items:json.hasOwnProperty('items') ? json.items : [json],cart}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true, detail:{baseEvent:'variant:add',cart}}));
    } catch (failure) {
      if (sheet === targetSheet) {
        const accepted = targetSheet.dataset.cartAdded === 'true';
        error.textContent = accepted ? t.added : failure?.lmShop ? failure.message : t.error;
        error.hidden = false;
        button.disabled = accepted;
        if (!accepted) targetSheet.querySelectorAll('[data-lm-size]').forEach((item) => {item.disabled = item.dataset.unavailable === 'true';});
      }
    } finally {
      cartPending = false;
      button.removeAttribute('aria-busy');
    }
  };
  const openSheet = async (card, plus) => {
    if (cartPending || plus.getAttribute('aria-busy') === 'true') return;
    if (sheet) closeSheet(false);
    opener = plus;
    openerSection = card.closest('[id^="shopify-section-"]')?.id;
    openerHandle = card.getAttribute('handle');
    const sequence = ++requestSequence;
    plus.setAttribute('aria-busy','true');
    ensureChoiceStyle(plus.dataset.lmChoiceCss);
    let product;
    try { product = await loadProduct(card); }
    catch (failure) {
      if (sequence === requestSequence && plus.isConnected) {
        let error = card.querySelector('[data-lm-choice-error]');
        if (!error) {error = document.createElement('p'); error.dataset.lmChoiceError = ''; error.setAttribute('role','alert'); plus.after(error);}
        error.textContent = t.error;
      }
      return;
    } finally { plus.removeAttribute('aria-busy'); }
    if (sequence !== requestSequence || !plus.isConnected) return;
    card.querySelector('[data-lm-choice-error]')?.remove();
    const variants = product.variants || [];
    const current = variants.find((item) => item.id === cardVariantId(card)) || variants.find((item) => item.available) || variants[0];
    if (!current) return;
    const swatches = card.querySelector('[data-option-position]');
    const colourIndex = swatches ? Number(swatches.dataset.optionPosition) - 1 : -1;
    const options = product.options || [];
    const sizeIndex = options.findIndex((option,index) => index !== colourIndex);
    const sameColour = variants.filter((item) => colourIndex < 0 || item.options[colourIndex] === current.options[colourIndex]);
    const order = ['XXS','XS','XS/S','S','S/M','M','M/L','L','L/XL','XL','XXL','2XL','XXXL','3XL','4XL','5XL'];
    if (sizeIndex >= 0 && sameColour.every((item) => order.includes(String(item.options[sizeIndex]).trim().toUpperCase()))) {
      sameColour.sort((a,b) => order.indexOf(String(a.options[sizeIndex]).trim().toUpperCase()) - order.indexOf(String(b.options[sizeIndex]).trim().toUpperCase()));
    }
    const link = card.querySelector('.product-card__figure > a');
    const url = link?.href || root + 'products/' + card.getAttribute('handle');
    const name = card.querySelector('.lm-nm')?.textContent.trim() || product.title;
    const image = card.querySelector('.lm-track img');
    const price = card.querySelector('.product-card__info price-list');
    const checked = card.querySelector('input[data-variant-media]:checked');
    /* CRO-64: the colour name is the radio's aria-label (snippets/option-value.liquid) */
    const colour = checked && (checked.getAttribute('aria-label') || card.querySelector('label[for="' + CSS.escape(checked.id) + '"] .sr-only')?.textContent.trim());
    const oneSize = lang === 'lt' ? 'Vienas dydis' : 'One size';
    const buttons = sameColour.map((variant) => {
      const value = sizeIndex >= 0 ? variant.options[sizeIndex] : oneSize;
      const label = value === 'Default Title' ? oneSize : value;
      return '<button type="button" aria-pressed="false" data-lm-size="' + variant.id + '" data-unavailable="' + !variant.available + '"' + (variant.available ? '' : ' disabled aria-label="' + esc(label + ', ' + t.out) + '"') + '>' + esc(label) + '</button>';
    }).join('');
    scrim = document.createElement('div'); scrim.className = 'lm-scrim show';
    sheet = document.createElement('div'); sheet.className = 'lm-sheet lm-choice-sheet show';
    const titleId = 'lm-sheet-title-' + sequence;
    sheet.setAttribute('role','dialog'); sheet.setAttribute('aria-modal','true'); sheet.setAttribute('aria-labelledby',titleId);
    sheet.innerHTML = '<div class="lm-sheet-h"><h2 id="' + titleId + '">' + esc(name + ' · ' + t.choose) + '</h2><button type="button" class="lm-sheet-x" aria-label="' + esc(t.close) + '">×</button></div>' +
      '<div class="lm-sheet-b"><div class="lm-sheet-li">' + (image ? '<img src="' + esc(image.currentSrc || image.src) + '" alt="">' : '<span></span>') + '<div><span class="lm-sheet-p"></span>' + (colour ? '<span class="lm-sheet-c">' + esc(colour) + '</span>' : '') + '</div></div>' +
      '<div class="lm-sizes" role="group" tabindex="-1" aria-label="' + esc(t.choose) + '">' + buttons + '</div><p class="lm-sheet-err" role="alert" hidden></p>' +
      '<button type="button" class="button" data-lm-card-add>' + esc(plus.dataset.lmAddLabel || 'Add to cart') + '</button><a class="lm-sheet-link" href="' + esc(url) + '">' + esc(t.details) + ' →</a></div>';
    if (price) sheet.querySelector('.lm-sheet-p').append(price.cloneNode(true));
    selectedVariant = null;
    const targetSheet = sheet;
    targetSheet.addEventListener('click', (event) => {
      if (event.target.closest('.lm-sheet-x')) {closeSheet(); return;}
      const choice = event.target.closest('[data-lm-size]');
      if (choice && !choice.disabled) {
        selectedVariant = Number(choice.dataset.lmSize);
        targetSheet.querySelectorAll('[data-lm-size]').forEach((item) => item.setAttribute('aria-pressed',String(item === choice)));
        targetSheet.querySelector('.lm-sheet-err').hidden = true;
      }
      const add = event.target.closest('[data-lm-card-add]');
      if (add) addToCart(card,add,selectedVariant);
    });
    targetSheet.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const items = sheetFocusables(targetSheet), first = items[0], last = items[items.length-1];
      if (!first) {event.preventDefault(); return;}
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {event.preventDefault(); last.focus();}
      else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {event.preventDefault(); first.focus();}
    });
    scrim.addEventListener('click', () => closeSheet());
    previousOverflow = document.documentElement.style.overflow;
    document.body.append(scrim,sheet);
    inertState = Array.from(document.body.children).filter((element) => element !== scrim && element !== sheet).map((element) => [element,element.inert]);
    inertState.forEach(([element]) => {element.inert = true;});
    document.documentElement.style.overflow = 'hidden';
    targetSheet.querySelector('.lm-sheet-x').focus({preventScroll:true});
  };
  document.addEventListener('click', (event) => {
    const heart = event.target.closest && event.target.closest('[data-lm-heart]');
    if (heart) {
      event.preventDefault();
      toggleSaved(heart);
      return;
    }
    const sizeButton = event.target.closest && event.target.closest('[data-lm-qs-size]');
    if (sizeButton) {
      event.preventDefault();
      const card = sizeButton.closest('product-card');
      if (card && !sizeButton.disabled) quickSize(card, sizeButton);
      return;
    }
    const plus = event.target.closest && event.target.closest('[data-lm-qadd]');
    if (plus) {
      event.preventDefault();
      const card = plus.closest('product-card');
      if (card && plus.getAttribute('aria-busy') !== 'true') openSheet(card, plus);
    }
  });

  document.querySelectorAll('product-card').forEach(bindCard);
  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches('product-card')) bindCard(node);
        node.querySelectorAll('product-card').forEach(bindCard);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}
